'use client'

export { Provider as JotaiProvider } from 'jotai'
